{
  "WEBCHAT": {
    "WIDGET": {
      "INPUT_MESSAGE": "Type here...",
      "DEFAULT_ASSISTANT_NAME": "Chat Receptionist"
    },
    "MULTI_LOCATION": {
      "RESPOND_IMMEDIATELY": "We respond immediately",
      "SEARCH_PLACEHOLDER": "Search by name or address...",
      "SEARCH_ARIA_LABEL": "Search locations",
      "ERROR_GENERIC": "Something went wrong.",
      "TRY_AGAIN": "Try again",
      "NO_LOCATIONS": "No locations found.",
      "PAGE": "Page {{ page }}",
      "POWERED_BY": "Powered by {{ name }}",
      "CHATTING_WITH": "Chatting with {{ name }}",
      "CLOSE_ARIA_LABEL": "Close widget",
      "BACK_ARIA_LABEL": "Back to location list",
      "PREV_PAGE_ARIA_LABEL": "Previous page",
      "NEXT_PAGE_ARIA_LABEL": "Next page"
    },
    "NEW_MESSAGE_RECEIVED": "New message received",
    "ERROR_SENDING_MESSAGE": "Failed to send message, please try again later.",
    "ERROR_CREATING_CONVERSATION": "Failed to create conversation, please try again later."
  }
}
